import { clientPortalRequest, buildClientQuery } from "./clientPortalFetch";

export function listClientCommunities(clientViewId, params = {}) {
  return clientPortalRequest(
    `/views/${clientViewId}/communities${buildClientQuery(params)}`
  );
}

export function getClientCommunity(clientViewId, communityId) {
  return clientPortalRequest(`/views/${clientViewId}/communities/${communityId}`);
}

export function createClientCommunity(clientViewId, body) {
  return clientPortalRequest(`/views/${clientViewId}/communities`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export function updateClientCommunity(clientViewId, communityId, body) {
  return clientPortalRequest(`/views/${clientViewId}/communities/${communityId}`, {
    method: "PATCH",
    body: JSON.stringify(body),
  });
}

export function updateClientCommunityStatus(clientViewId, communityId, displayStatus) {
  return clientPortalRequest(`/views/${clientViewId}/communities/${communityId}/status`, {
    method: "PATCH",
    body: JSON.stringify({ displayStatus }),
  });
}

export function archiveClientCommunity(clientViewId, communityId) {
  return clientPortalRequest(`/views/${clientViewId}/communities/${communityId}`, {
    method: "DELETE",
  });
}
